import { render } from "./ViewFormDetailModal.vue?vue&type=template&id=8ac5f522&ts=true"
import script from "./ViewFormDetailModal.vue?vue&type=script&lang=ts"
export * from "./ViewFormDetailModal.vue?vue&type=script&lang=ts"

import "./ViewFormDetailModal.vue?vue&type=style&index=0&id=8ac5f522&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__